import React, { useState } from "react";
import Packages from "../../pages/Packages";
import { LiaAdSolid } from "react-icons/lia";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { MdOutlineReportGmailerrorred } from "react-icons/md";
import { FaCartArrowDown } from "react-icons/fa";
import Ads from "../../pages/Ads";
import Orders from "../../pages/Orders";
import i18n from "../../lib/i18n";
import Reports from "../../pages/reports";

const TabsExample = () => {
  const [activeTab, setActiveTab] = useState("User Ads");
  const t = i18n.t.bind(i18n); 

  const tabs = [
    { key: "security", label: t("user.report_tap"), icon: <FaRegMoneyBillAlt size={24}/> },
    { key: "User Orders", label: t("user.order_tap"), icon: <FaCartArrowDown size={24}/> },
    { key: "User Ads", label: t("user.ads_tap"), icon: <LiaAdSolid size={24}/> },
  ];

  return (<>
    <div className="w-full px-8 ">
      <div className="flex justify-around items-center rounded-lg bg-thirdly py-2">
        {tabs.map((tab) => (
          <button key={tab.key} onClick={() => setActiveTab(tab.key)} className={`flex items-center justify-center gap-3 px-4 py-2 rounded-md text-sm font-medium transition ${ activeTab === tab.key ? "bg-purple-500 text-white" : "text-gray-300 hover:bg-gray-700 hover:text-white"}`}>
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>
      {/* {activeTab === "User Ads" &&
        <div className="bg-furthly py-4 rounded-t-lg border-b border-gray-500/40 top-[32px] relative ">
          <h2 className="font-bold text-center text-xl text-white">User Ads</h2>
        </div>
      } */}
    </div>
    <div>
      {activeTab === "security" && <Reports />}
      {activeTab === "User Orders" && <Orders />}
      {activeTab === "User Ads" && <Ads />}
    </div>
  </>);
};

// Example components

export default TabsExample;
